import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IngFilter, Ingredient, ListFilter } from '../models/List.Ingredient';

@Injectable({
  providedIn: 'root'
})
export class RestaurantIngredientService {

  refreshList = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  GetIngredientForRestaurant(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResRestaurantIngredient/ResGetIngredientForRestaurant`, filter);
  }
  GetRestaurantIngredient(filter: IngFilter): any {
    return this.http.post(`${environment.apiUrl}/ResRestaurantIngredient/ResGetRestaurantIngredient`, filter);
  }
  GetIngredientUnit(): any {
    return this.http.get(`${environment.apiUrl}/ResRestaurantIngredient/ResGetIngredientUnit`);
  }
  saveRecord(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurantIngredient/ResEditRestaurantIngredient`, data);
  }
  checkPermission(data: any) {
    return this.http.post(`${environment.apiUrl}/ResRestaurantIngredient/ResCheckRestaurantIngredientPermission`, data);
  }
}
